import { createSlice } from '@reduxjs/toolkit';

const tokensSlice = createSlice({
  name: 'tokens',
  initialState: {
    accessToken: '',
    refreshToken: '',
    userEmail: '',
    userPhoneNumber: '',
    accessTokenExpiration: null,
    refreshTokenExpiration: null,
    userRole: '',
  },
  reducers: {
    setAccessToken(state, action) {
      state.accessToken = action.payload;
    },
    setRefreshToken(state, action) {
      state.refreshToken = action.payload;
    },
    setUserEmail(state, action) {
      state.userEmail = action.payload;
    },
    setUserPhoneNumber(state, action) {
      state.userPhoneNumber = action.payload;
    },
    setAccessTokenExpiration(state, action) {
      state.accessTokenExpiration = action.payload;
    },
    setRefreshTokenExpiration(state, action) {
      state.refreshTokenExpiration = action.payload;
    },
    clearTokens(state) {
      state.accessToken = '';
      state.refreshToken = '';
      state.userEmail = '';
      state.userPhoneNumber = '';
      state.accessTokenExpiration = null;
      state.refreshTokenExpiration = null;
      state.userRole = '';
    },
    setTokens(state, action) {
      const {
        accessToken,
        refreshToken,
        userEmail,
        userPhoneNumber,
        accessTokenExpiration,
        refreshTokenExpiration,
        userRole,
      } = action.payload;
      state.accessToken = accessToken;
      state.refreshToken = refreshToken;
      state.userEmail = userEmail;
      state.userPhoneNumber = userPhoneNumber;
      state.accessTokenExpiration = accessTokenExpiration;
      state.refreshTokenExpiration = refreshTokenExpiration;
      state.userRole = userRole;
    },
    setAccessTokenWithExpiration(state, action) {
      const { accessToken, accessTokenExpiration } = action.payload;
      state.accessToken = accessToken;
      state.accessTokenExpiration = accessTokenExpiration;
    },
  },
});

export const {
  setAccessToken,
  setRefreshToken,
  setAccessTokenExpiration,
  setRefreshTokenExpiration,
  setTokens,
  setUserEmail,
  setUserPhoneNumber,
  clearTokens,
  setAccessTokenWithExpiration,
} = tokensSlice.actions;
export default tokensSlice.reducer;
